import React, { useEffect, useState } from "react";
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import { Image } from "../componentIndex";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { Button, CheckBox, RadioButton } from "../../common/commonIndex";

const SearchResultFilter = ({ closeSearchFilterScreen, doctors, activeFilterData, genderFilter }) => {
    const [practiceList, setPracticeList] = useState([]);
    const [checkBoxList, setCheckBoxList] = useState([]);
    const [gender, setGender] = useState("");
    const [languages, setLanguages] = useState([]);
    const [isPracticeOpen, setIsPracticeOpen] = useState(true);
    const [isLanguageOpen, setIsLanguageOpen] = useState(true);

    // const practiceList = ["Novant Medical Center", "Metro Gastroenterology", "Carolina Digestive"]
    const genderList = ["Male", "Female", "Non-binary"]
    const languageSpoken = ["English", "Portuguese", "Spanish", "Vietnamese", "Mandarin", "Haitian Creole", "Arabic", "Hindi"]

    useEffect(() => {
        console.log('doctors', doctors);
        // let findOrganizationNames = doctors?.map(x => x.organizationName);
        let findOrganizationNames = [...new Set(doctors?.map(x => x.organizationName))];

        setPracticeList(findOrganizationNames);
    }, [])
    useEffect(() => {
        setCheckBoxList(activeFilterData);
        setGender(genderFilter);
    }, [activeFilterData, genderFilter])

    const closeFullScreen = (type) => {
        if(type === 'clear'){
            closeSearchFilterScreen([]);
        }else{
            closeSearchFilterScreen(checkBoxList,gender);
        }
    }

    /* Callback function to handle radio button change */
    const handleRadioChange = (question) => (value) => {
        const stateMap = {
            'practice': [checkBoxList, setCheckBoxList],
            'gender': [gender, setGender],
            'languages': [languages, setLanguages],
        };
        // Retrieve the current state and setter function based on the question
        const [state, setState] = stateMap[question] || [];
        // Only proceed if the state and setter exist for the provided question
        if (state && setState) {
            if (state?.includes(value)) {
                // Remove the value if it's already selected
                setState(state.filter(item => item !== value));
            } else {
                // Add the value if it's not yet selected
                setState([...state, value]);
            }
        }
    };

    const handleToggle = (accordionName) => {
        if (accordionName === 'practice') {
            setIsPracticeOpen((prev) => !prev);
            // setIsPracticeOpen(!isPracticeOpen);
        } else if (accordionName === 'languages') {
            // setIsLanguageOpen(!isLanguageOpen);
            setIsPracticeOpen((prev) => !prev);
        }
    };
    const handleClearAll = () => {

        setCheckBoxList([]);

        setGender(null);
        setLanguages([]);
        closeFullScreen('clear');
    }

    return (
        <div className="">
            <div className="content-padding header">
                <div className="row">
                    <div className="col-4 text-left" onClick={closeFullScreen}>
                        <Image imgUrl={CloseIcon} altText={'close'} className={'popup-close-icon cursor-pointer'} />
                    </div>
                    <div className="col-4">
                        <p className="mb-0 modal-title">Filters</p>
                    </div>
                    <div className="col-4"></div>
                </div>
            </div>
            <div className="divider"></div>
            <div className="content-padding">
                <div className={`${practiceList && practiceList?.length > 8 ? 'scrollbar language-scrollbar' : ''}`}>
                    <div className={`${practiceList && practiceList?.length > 8 ? 'force-overflow' : ''}`}>
                        {/* <div className=""> */}
                            <Accordion preExpanded={['a', 'c']}>
                                <AccordionItem uuid="a">
                                    <AccordionItemHeading >
                                        <AccordionItemButton onClick={() => handleToggle('practice')}>
                                            Practice
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    {isPracticeOpen && (
                                        <AccordionItemPanel>
                                            {practiceList?.map((item, index) => (
                                                <div key={index}>
                                                    {/* organizationName */}
                                                    <CheckBox
                                                        checkBox="practice"
                                                        name={item}
                                                        id={index}
                                                        onCheckBoxChange={() => handleRadioChange('practice')}
                                                        formData={doctors}
                                                        isAllergiesCheck={true}
                                                        value={checkBoxList}
                                                        setValue={setCheckBoxList}

                                                    />
                                                </div>
                                            ))}
                                        </AccordionItemPanel>
                                    )}
                                </AccordionItem>
                            </Accordion>
                        {/* </div> */}
                        <div className="divider my-3 me-3"></div>
                        {/* <div className=""> */}
                            <h5 className="gender-title">Gender</h5>
                            <div className="list colonoscopy-radio filter-gender mb-5 pb-3">
                                {genderList?.map((item, index) => {
                                    const isSelected = gender === item;
                                    const className = isSelected ? "list-item selected selected" : "list-item selected";

                                    return (
                                        <div className={className} key={index}>
                                            <RadioButton
                                                radioButton="gender"
                                                name={item}
                                                id={index}
                                                onRadioChange={() => handleRadioChange('gender')}
                                                formData={genderList}
                                                value={gender}
                                                setValue={setGender}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        {/* </div> */}
                        {/* <div className="divider my-3 me-3"></div> */}
                        <div className="footer-content">
                            <div className="justify-content-between ">
                                <Button
                                    btnClass={'btn-border-0-secondary'}
                                    btnName={'Clear all'}
                                    btnType={'button'}
                                    isDisabled={true}
                                    onClick={handleClearAll}
                                />
                                <Button
                                    btnClass={'btn-primary btn-filter-doctor'}
                                    btnName={'Done'}
                                    btnType={'button'}
                                    isDisabled={true}
                                    onClick={closeFullScreen}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SearchResultFilter;